import React from 'react';
import { UserList } from '../../../icons';

export const CardListSkeletion = () => {
  return Array.from({ length: 9 }, (_, index) => (
    <div
      key={index}
      className={
        'p-3 animate-pulse bg-white flex w-full items-center gap-3 rounded-lg'
      }
    >
      <div className={'rounded-full bg-powdergrey w-10 h-10 leading-10'} />
      <div className="flex flex-col gap-2">
        <div className="w-20 h-5 bg-powdergrey rounded-full" />
        <div className="w-40 h-5 bg-powdergrey rounded-full" />
      </div>
    </div>
  ));
};

export const FormSkeletion = () => {
  return (
    <div className="animate-pulse max-lg:w-full">
      <div className="grid lg:grid-cols-2 gap-5 driver-form lg:min-w-[500px] lg:max-w-[700px]">
        <div className="animate-pulse">
          <label
            htmlFor="name"
            className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
          ></label>
          <input
            type="text"
            id="name"
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            placeholder="name"
          />
        </div>
        <div className="animate-pulse">
          <label
            htmlFor="surName"
            className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
          ></label>
          <input
            type="text"
            id="surName"
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            placeholder="surname"
          />
        </div>

        <div className="animate-pulse">
          <label
            htmlFor="email"
            className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
            placeholder="email"
          ></label>
          <input
            type="email"
            id="email"
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            placeholder="email"
          />
        </div>
        <div className="animate-pulse">
          <label
            htmlFor="phoneNumber"
            className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
          ></label>
          <input
            type="tel"
            id="phoneNumber"
            placeholder="phoneNumber"
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
          />
        </div>
        <div className="animate-pulse">
          <label
            htmlFor="place"
            className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
          ></label>
          <input
            type="text"
            id="place"
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            placeholder="place"
          />
        </div>
        <div className="animate-pulse">
          <label
            htmlFor="city"
            className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
          ></label>
          <input
            type="text"
            id="city"
            placeholder="city"
            className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
          />
        </div>

        <button
          disabled=""
          tabIndex="-1"
          className="align-middle select-none font-sans font-bold text-center uppercase transition-all disabled:opacity-50 disabled:shadow-none disabled:pointer-events-none text-xs py-3 px-6 rounded-lg text-white shadow-gray-900/10 hover:shadow-gray-900/20 focus:opacity-[0.85] focus:shadow-none active:opacity-[0.85] active:shadow-none h-8 w-20 bg-gray-300 shadow-none hover:shadow-none"
          type="button"
        >
          &nbsp;
        </button>
      </div>
    </div>
  );
};

// to be updated
export const TableSkeletion = () => {
  return Array.from({ length: 9 }, (_, index) => (
    <div
      key={index}
      className={
        'p-3 animate-pulse bg-white flex w-full items-center gap-3 rounded-lg'
      }
    >
      <div className={'rounded-full bg-powdergrey w-10 h-10 leading-10'} />
      <div className="flex flex-col gap-2">
        <div className="w-20 h-5 bg-powdergrey rounded-full" />
        <div className="w-40 h-5 bg-powdergrey rounded-full" />
      </div>
    </div>
  ));
};

export const ReportsSkeletion = () => {
  // to do create correct skeletion
  return (
    <div
      className={
        'p-3 animate-pulse bg-white flex w-full items-center gap-3 rounded-lg'
      }
    >
      <div className={'rounded-full bg-powdergrey w-10 h-10 leading-10'} />
      <div className="flex flex-col gap-2">
        <div className="w-20 h-5 bg-powdergrey rounded-full" />
        <div className="w-40 h-5 bg-powdergrey rounded-full" />
      </div>
    </div>
  );
};

export const CardSkeletion = () => {
  return (
    <div className="animate-pulse bg-white h-full p-6 rounded-xl flex flex-col gap-4">
      <ul className="flex flex-col gap-4">
        <li className="animate-pulse flex justify-between flex-1"></li>
        <li className="animate-pulse flex justify-between flex-1"></li>
        <li className="animate-pulse flex justify-between flex-1"></li>
        <li className="animate-pulse flex justify-between flex-1"></li>
        <li className="animate-pulse flex justify-between flex-1"></li>
        <li className="animate-pulse flex justify-between flex-1"></li>
      </ul>
    </div>
  );
};

export const ListSkeletion = () => {
  return (
    <li className="animate-pulse flex bg-white justify-between py-3 px-6 rounded-lg">
      <div className="flex gap-3 items-center">
        <div className="animate-pulse rounded-full  bg-powdergrey p-3">
          <UserList />
        </div>
      </div>
    </li>
  );
};
